import DD from '../dropdown/DD.react';

class Picklist extends React.Component {

    render() {
        var self = this,
            tabindex = this.props.tabindex || '';

        return (
            <div>
                <DD
                    className='picklist-header'
                    disabled={this.props.disabled}
                    value={''}
                    onChange={e => { this.props.onChange(e); }}
                    options={[{ title: '(add)', option: '' }]
                        .concat(this.props.options)
                    } />

                {this.props.values.map(v => (
                    <div className='dd-base'>{v.title}
                        <i
                            className='fa fa-window-close picklist-delete-icon'
                            onClick={() => { this.props.OnRemove(v.option) }}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

export default Picklist;



// WEBPACK FOOTER //
// ./ui_src/app/components/form/picklist/Picklist.react.jsx